export class GetTableDataQualitySchemaChangesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "events",
            "baseName": "events",
            "type": "Array<SchemaChangeEvent>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualitySchemaChangesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
